/**
 * @generated SignedSource<<89d3206a18dd1ff454b9b313357cb3c7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AssociationType = "MANDATORY" | "OPTIONAL";
export type HealthInformationStatus = "NONE" | "SOME" | "UNKNOWN";
import { FragmentRefs } from "relay-runtime";
export type PatientAllergiesOutputFragment$data = {
  readonly allergies: ReadonlyArray<{
    readonly comment: string | null;
    readonly icdDiagnosis: {
      readonly associationType: AssociationType | null;
      readonly diagnosisCode: string;
      readonly id: string;
      readonly isAssociation: boolean;
      readonly primaryCode: string | null;
      readonly secondaryCode: string | null;
      readonly text: string;
    };
    readonly id: string;
  }>;
  readonly id: string;
  readonly status: HealthInformationStatus;
  readonly " $fragmentType": "PatientAllergiesOutputFragment";
};
export type PatientAllergiesOutputFragment$key = {
  readonly " $data"?: PatientAllergiesOutputFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientAllergiesOutputFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PatientAllergiesOutputFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AllergyOutput",
      "kind": "LinkedField",
      "name": "allergies",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "comment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IcdDiagnosis",
          "kind": "LinkedField",
          "name": "icdDiagnosis",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAssociation",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "diagnosisCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondaryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "associationType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PatientAllergiesOutput",
  "abstractKey": null
};
})();

(node as any).hash = "a70d9b1cba86499ca2fae4c5d561f995";

export default node;
